import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { IconsModule } from '@shared/icons/icons.module';
import { CompanyInfoComponent, InfoComponent } from './components';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';

@NgModule({
  imports: [CommonModule, TranslateModule, IconsModule, RouterModule, PipesSharedModule, CustomTooltipModule],
  declarations: [InfoComponent, CompanyInfoComponent],
  exports: [InfoComponent, CompanyInfoComponent],
})
export class InfoModule {}
